import { render, staticRenderFns } from "./TestTopbar.vue?vue&type=template&id=21a325b6&scoped=true&"
import script from "./TestTopbar.vue?vue&type=script&lang=js&"
export * from "./TestTopbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a325b6",
  null
  
)

export default component.exports